import { render, staticRenderFns } from "./keywordOfModalTable.vue?vue&type=template&id=49c49bcf&scoped=true"
import script from "./keywordOfModalTable.vue?vue&type=script&lang=js"
export * from "./keywordOfModalTable.vue?vue&type=script&lang=js"
import style0 from "./keywordOfModalTable.vue?vue&type=style&index=0&id=49c49bcf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c49bcf",
  null
  
)

export default component.exports